
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import numberFormats from 'utils/numberFormats'

export default class NumberFormat extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    format: PropTypes.oneOf(Object.keys(numberFormats)),
    currency: PropTypes.string,
    className: PropTypes.string
  }

  static contextTypes = {
    currency: PropTypes.string
  }

  static defaultProps = {
    format: 'number'
  }

  render() {
    const {format, value, currency, className} = this.props
    const {currency: contextCurrency} = this.context
    const classNames = classnames('number-format', {[`is-${format}`]: !!format}, className)

    let options = [value]

    if (format === 'currency') {
      options.push(currency || contextCurrency)
    }

    return (
      <span className={classNames}>{numberFormats[format].apply(null, options)}</span>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/NumberFormat/index.js